import axios from 'axios'

export const api = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json'
    }
})

export const getTraductions = () => {
    return api.get('traductions')
}

export const getTriennats = () => {
    return  api.get('triennats')
}

export const getTriennatEnCours = () => {
    return api.get('triennats/encours')
}

export const getSessions = () => {
    return api.get('sessions')
}

export const getOrganisationsFormatrices = () => {
    return api.get('organisationsFormatrices')
}

export const getHeuresAdmissibles = (contactId) => {
    return api.get('heuresAdmissibles/' + contactId)
}

export const postHeuresAdmissibles = (contactId, heures) => {
    return api.post('heuresAdmissibles/' + contactId, heures)
}